export default __webpack_public_path__ + "static/merchandise-0fecba784415bced4250a0113b5ac4f4.jpg";